define([
	"dojo/_base/declare",
	"csi/table/Preferences"
], function(declare,Preferences) {

	return declare(Preferences, {
		constructor: function() {
			this.addCustomOption("displayCommentLines", true, false, "DisplayCommentLines");
		}
	});
});